module.exports = __webpack_public_path__ + "static/ht-main-banner-image-bdab7f769c50b6943a886cd437d7f422.png";